import { formatDate } from '@wix/da-i18next/pkg/time/functions';

export const formatBalance = (balance, currency?: true) =>
  Intl.NumberFormat('en-US', {
    signDisplay: 'exceptZero',
    style: currency ? 'currency' : undefined,
    currency: currency ? 'USD' : undefined,
    useGrouping: false,
  }).format(balance);

export const formatMonth = (date: string) =>
  formatDate(date, { month: 'short' });
